import axios, { AxiosInstance } from 'axios'
import { authEvent } from '../events/AuthEvent'

export const { VITE_DOMAIN_API } = import.meta.env
const DOMAIN_API = ''

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: DOMAIN_API + '/api',
  timeout: 60000,
})

export const axiosSanctumInstance: AxiosInstance = axios.create({
  baseURL: DOMAIN_API,
  withCredentials: true,
  timeout: 60000,
})

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      authEvent.emit('unauthenticated')
      return
    }
    return Promise.reject(error)
  }
)
